import { fetchAuthSession } from "@aws-amplify/auth";
import axios from "axios";

/**
 * 既存のAPIにリクエストを送信するためのもの
 * 新規APIの場合は apiV1Client を使用すること
 */
export const apiV0Client = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v0` || "http://localhost:8080",
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
  withCredentials: false, // クッキーを使う場合は true にする
});

apiV0Client.interceptors.request.use(async (config) => {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * 新規API用
 */
export const apiV1Client = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v1` || "http://localhost:8080",
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
  withCredentials: false, // クッキーを使う場合は true にする
  timeout: 30_000, // タイムアウトは 30 秒
});

apiV1Client.interceptors.request.use(async (config) => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (!token) {
      return Promise.reject(new axios.Cancel("トークンがありません"));
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
  } catch (error) {
    return Promise.reject(new axios.Cancel("Failed to fetch auth session"));
  }
});
